





































































































import { Component, Prop } from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import Modal from '@/components/Modal.vue';
import { ISentenceCheck } from '@/util/content-check/common';

@Component({
  components: {
    modal: Modal
  }
})
export default class ContentCheckResult extends CommonVue {
  @Prop({ type: Object }) public data!: ISentenceCheck;
}
